import React from "react";
import { services } from "../mock";
import { Building2, Landmark, Home, MapPinned, Compass, Layers } from "lucide-react";

const ICONS = { Building2, Landmark, Home, MapPinned, Compass, Layers };

const Services = () => {
  return (
    <section id="services" className="section-pad bg-[#f5f5f4]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-serif-display text-[#0e0e0f]" style={{ fontSize: "clamp(2rem, 4vw, 3.5rem)" }}>
            Expertiza Noastră
          </h2>
          <p className="mt-4 text-neutral-500 text-[17px]">
            De la concept la finalizare, livrăm excelență arhitecturală.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const Icon = ICONS[s.icon];
            return (
              <div
                key={s.title}
                className="bg-white rounded-2xl p-8 hover-lift border border-transparent hover:border-[#f5b301]/30"
                style={{ boxShadow: "0 1px 2px rgba(0,0,0,0.04)" }}
              >
                <div className="w-14 h-14 rounded-xl bg-[#fef3c7] flex items-center justify-center">
                  {Icon ? <Icon size={26} className="text-[#eab308]" strokeWidth={1.8} /> : null}
                </div>
                <h3 className="mt-6 text-[#0e0e0f] font-semibold text-xl">{s.title}</h3>
                <p className="mt-3 text-neutral-500 leading-relaxed text-[15px]">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
